import { AxiosInstance } from 'axios';
import { axiosProxy } from '@/plugins/axios';

export class TranslationRepository {
  
  private api: AxiosInstance = axiosProxy;


  async getTranslations(includes: string = '') {
    try {
      try {
        // http://v3.taiko.local/api/translations?include=associations,professions
        const res = await this.api.get(`translations?include=${includes}`);
        if (res.data['data']) {
          return res.data['data'];
        }
        throw Error("Data not available on response");
      } catch (error) {
        throw error;
      }
    } catch (error) {
      throw error;
    }

  }


}